import React from 'react'
import { Dropdown, Button } from 'antd'
import { DownOutlined } from '@ant-design/icons'
import { useAuthContext } from 'contexts';

export const DropdownMenu2 = ({
    title = '',
    onRequeue = () => { },
    onHPRequeue = () => { },
    onReset = () => { },
    onClose = () => { },
    onDevRelay = () => { },
    onStagingRelay = () => { },
    onDeleteCircular = () => { },
    onPageReset = () => {},
    disabled = false,
}) => {
    // TODO: Make it reusable
    const { userInfo } = useAuthContext();

    const menuItems = [
        {
            key: 'requeue',
            label: 'Requeue',
            onClick: onRequeue,
            disabled: disabled,
        },
        {
            key: 'hp-requeue',
            label: 'HP Requeue',
            onClick: onHPRequeue,
            disabled: disabled,
        },
        ...(userInfo.user?.is_superuser ? [
            {
                key: 'reset-page',
                label: 'Reset Page',
                onClick: onPageReset,
                disabled: disabled,
            },
            {
                key: 'reset',
                label: 'Reset',
                onClick: onReset,
                disabled: disabled,
            }
        ] : []),
        ...(userInfo.user?.is_superuser || userInfo.user?.is_moderator ? [
            {
                key: 'delete',
                label: 'Delete',
                onClick: onDeleteCircular,
                disabled: disabled,
                danger: true,
            }
        ] : []),
        {
            type: 'divider',
        },
        {
            key: 'copy-dev',
            label: 'Copy To Dev',
            onClick: onDevRelay,
            disabled: disabled,
        },
        {
            key: 'copy-staging',
            label: 'Copy To Staging',
            onClick: onStagingRelay,
            disabled: disabled,
        },
        {
            type: 'divider',
        },
        {
            key: 'close',
            label: 'Close',
            onClick: onClose,
            disabled: disabled,
        },
    ];

    return (
        <Dropdown
            menu={{ items: menuItems }}
            trigger={['click']}
            disabled={disabled}
            placement="bottomLeft"
        >
            <Button
                color="default" 
                variant="filled"
                loading={disabled}
            >
                {title}
                <DownOutlined style={{ fontSize: '10px', marginLeft: '8px' }} />
            </Button>
        </Dropdown>
    )
}


